export const RenderSubtitle = ({ propertyFeature }) => {
  return propertyFeature?.subTitle;
};
